import React from "react";
import { useDispatch } from "react-redux";
import {
  resetAgreementStatusAction,
  showErrorMessage,
  showSuccessMessage,
} from "../../../../actions";
import { resolveErrorMessage } from "../../../../util";
import ActionDialog from "../../ActionDialog";
import { Typography } from "@material-ui/core";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import LoadingSpinner from "../../LoadingSpinner";

const RestartAgreementDialog = ({ open, onClose, user, fetchUser }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);

  const resetAgreementStatus = async () => {
    setLoading(true);
    try {
      await resetAgreementStatusAction({ editedUserId: user.id });
      dispatch(showSuccessMessage("app.contractAgent.restarted"));
      await fetchUser();
    } catch (e) {
      const errorMessage = resolveErrorMessage(e);
      dispatch(showErrorMessage(errorMessage));
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <ActionDialog
      title="app.confirmations"
      open={open}
      onClose={onClose}
      onAccept={resetAgreementStatus}
      disableConfirmButton={loading}
    >
      {loading ? (
        <LoadingSpinner
          message={<FormattedMessage id="app.loading.updating" />}
        />
      ) : (
        <>
          <Typography variant="body1" paragraph>
            <FormattedHTMLMessage id="app.contractAgent.confirmRestart1" />
          </Typography>
          <Typography variant="body1">
            <FormattedHTMLMessage id="app.contractAgent.confirmRestart2" />
          </Typography>
        </>
      )}
    </ActionDialog>
  );
};

export default React.memo(RestartAgreementDialog);
